import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import { transparentize } from 'polished'

import { isTouchDevice } from '../../../components/utils/displayUtils'

import ChevronDownIcon from '../../../components/icons/ChevronDown'
import LazyImage from '../../../components/display/LazyImage'

export const MobileListingSliderWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-top: 75%;
  background-color: #333;

  transform: translate3d(0, 0, 0);

  ${LazyImage} {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
`

export const Image = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
`

export const SliderImage = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 75%;
  background-color: #333;

  ${LazyImage} {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
`

const Arrow = styled.button`
  position: absolute;

  height: 36px;
  width: 36px;
  padding: 0;

  top: 50%;
  transform: translateY(-50%);

  ${({ left }) =>
    left &&
    `
    left: 8px;
    svg {
      margin-left: -2px;
    }
  `}

  ${({ right }) =>
    right &&
    `
    right: 8px;
    svg {
      margin-right: -2px;
    }
  `}

  appearance: none;
  outline: 0;
  border: none;
  border-radius: 50%;
  background-color: ${({ theme }) => transparentize(0.3, theme.brand.forest)};

  svg {
    display: inline-block;
    vertical-align: middle;
    height: 13px;
    margin-top: -2px;
    color: white;
    transform: rotate(${({ left }) => (left ? '90deg' : '-90deg')});
  }
`

const SliderWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;

  &:hover {
    ${Arrow} {
      opacity: 1;
    }
  }

  ${({ onTouchDevice }) =>
    onTouchDevice &&
    `
    ${Arrow} {
      opacity: 1 !important;
    }
  `}
`

const SliderSettings = {
  arrows: false,
  dots: false,
  infinite: true,
  adaptiveHeight: false,
}

export default class MobileListingSlider extends React.Component {
  render() {
    const { photos } = this.props
    return (
      <MobileListingSliderWrapper>
        <SliderWrapper onTouchDevice={isTouchDevice()}>
          <Slider
            ref={(slider) => {
              this.Slider = slider
            }}
            {...SliderSettings}
          >
            {photos.map((photo) => (
              <div key={photo.id}>
                <SliderImage>
                  <LazyImage data-src={photo.image.medium} />
                </SliderImage>
              </div>
            ))}
          </Slider>
          <Arrow left onClick={() => this.Slider.slickPrev()}>
            <ChevronDownIcon />
          </Arrow>
          <Arrow right onClick={() => this.Slider.slickNext()}>
            <ChevronDownIcon />
          </Arrow>
        </SliderWrapper>
      </MobileListingSliderWrapper>
    )
  }
}
